import React from 'react';
import { Controller, Control } from 'react-hook-form';
import cx from 'classnames';
import { IconRadioChecked, IconRadioEmpty } from '@/components/icons';

type Option = {
  label: string;
  value: string;
  disabled?: boolean;
};

type CustomRadioGroupProps = {
  name: string;
  control: Control<any>;
  options: Option[];
  className?: string;
};

export const CustomRadioGroup: React.FC<CustomRadioGroupProps> = ({
  name,
  control,
  options,
  className,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <div className={cx('flex gap-4 w-full', className)} role="radiogroup">
          {options.map(({ value, label, disabled }) => {
            const isSelected = field.value === value;
            return (
              <button
                key={value}
                type="button"
                onClick={() => !disabled && field.onChange(value)}
                className={cx(
                  'flex items-center w-full gap-2 px-4 py-2 rounded-lg transition border border-gray-300 bg-white',
                  {
                    'opacity-50 cursor-not-allowed': disabled,
                  },
                )}
                role="radio"
                aria-checked={isSelected}
                disabled={disabled}
              >
                {isSelected ? <IconRadioChecked /> : <IconRadioEmpty />}
                <span>{label}</span>
              </button>
            );
          })}
        </div>
      )}
    />
  );
};
